import {Observable} from 'rxjs';
import {Platform}   from './api.models';
import {Http}       from '@angular/http';
import {Settings}   from '../../../settings.model';
import {Request}    from '../../../request.abstract';

export class MessageCentralEndpoint extends Request {
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    platforms(): Observable<Platform[]> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/messagecentral/platforms');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/messagecentral/api.service.ts